import React from 'react';

const skillGroups = [
    {
        title: 'Programming Languages',
        skills: ['Python', 'Go', 'JavaScript', 'Java', 'SQL'],
    },
    {
        title: 'Web Development',
        skills: ['React', 'Gin', 'Tailwind CSS'],
    },
    {
        title: 'Data Science & AI',
        skills: ['PyTorch', 'Scikit-learn', 'Pandas', 'NumPy', 'WandB'],
    },
    {
        title: 'Tools & Platforms',
        skills: ['Git', 'Docker', 'Google Cloud', 'Firebase'],
    },
];

const Skills = () => {
    return (
        <section className="w-full flex items-center justify-center dark:bg-earth-900 py-20 overflow-hidden">
            <div className="w-full max-w-7xl px-8 lg:px-6">
                <div className="mb-14">
                    <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-earth-900 dark:text-earth-50 leading-tight mb-6 text-center">
                        Skills & Technologies
                    </h2>
                </div>

                <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
                    {skillGroups.map((group) => (
                        <div
                            key={group.title}
                            className="w-full rounded-3xl sm:p-8 dark:border-earth-100/20"
                        >
                            <h3 className="text-lg sm:text-xl font-bold text-earth-900 dark:text-earth-50 mb-4 text-center">
                                {group.title}
                            </h3>
                            <div className="flex flex-wrap justify-center gap-2">
                                {group.skills.map((skill) => (
                                    <div
                                        key={skill}
                                        className="rounded-full border border-earth-800 bg-transparent dark:bg-earth-800/30 dark:border-earth-100/30 px-4 py-2 text-sm sm:text-base font-medium text-earth-900 dark:text-earth-50"
                                    >
                                        {skill}
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Skills;
